import { render, staticRenderFns } from "./AuxiliaryEdit.vue?vue&type=template&id=56a63a59&scoped=true&"
import script from "./AuxiliaryEdit.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a63a59",
  null
  
)

export default component.exports